import React from 'react';
import { type PropsWithChildren } from 'react';

import { DisplayText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuDietaryPreferencesHeading = (props: PropsWithChildren) => {
  const { children } = props;

  return <DisplayText sizeMatch={['32']}>{children}</DisplayText>;
};
